export const getDate = (date) => {
    if(date){
        const fecha = new Date(date);
        const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
        return fecha.getUTCDate() + " de " + months[fecha.getMonth()] + " del " + fecha.getFullYear();
    } else return "";
}

export const sortData = (data) => {
    let sorted = data.sort((a, b) => {
        let fa = a.sCampus.toLowerCase(),
            fb = b.sCampus.toLowerCase();
    
        if (fa < fb) {
            return -1;
        }
        if (fa > fb) {
            return 1;
        }
        return 0;
    });

    return sorted;
}